// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ssd4","largestCol":"styles_largestCol__wSSMi","smallestCol":"styles_smallestCol__2d-Yw"};